// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-BSOts2","itemSelected":"itemSelected-bZIR9d","menu":"menu-oZa03m","staticLabel":"staticLabel-Bi2ILH"};